@for (item of menuService.selectedSubMenu(); track item.archiveId) {
    <div
        class="editor-container"
        [class.is-editing]="item.isEdit"
    >
        <kendo-toolbar>
            <app-toolbox-type [type]="item.type"></app-toolbox-type>
            <kendo-toolbar-spacer></kendo-toolbar-spacer>
            @if (item.isEdit) {
                <kendo-toolbar-button
                    showText="always"
                    text="Sauver"
                    (click)="sauvegarder(item)"
                >
                </kendo-toolbar-button>
                <kendo-toolbar-button
                    showText="always"
                    text="Annuler"
                    (click)="switchEdit(item)"
                >
                </kendo-toolbar-button>
            } @else {
                <kendo-toolbar-button
                    showText="always"
                    text="Ajouter en haut"
                    (click)="ajouter(item, true)"
                >
                </kendo-toolbar-button>
                <kendo-toolbar-button
                    showText="always"
                    text="Ajouter en bas"
                    (click)="ajouter(item, false)"
                >
                </kendo-toolbar-button>
                <kendo-toolbar-button
                    showText="always"
                    text="Édition"
                    [disabled]="swEdit"
                    (click)="switchEdit(item)"
                >
                </kendo-toolbar-button>
                <app-custom-tool [text]="'le ' + (item.lastEdit | date: 'dd.MM.yyyy')"></app-custom-tool>
            }
        </kendo-toolbar>
        @if (item.isEdit) {
            @if (item.type === 'Texte') {
                <kendo-editor
                    [(value)]="value"
                    class="editor-instance"
                >
                    <kendo-toolbar>
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                        <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                        <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                        <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                        <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                        <kendo-toolbar-colorpicker
                            kendoEditorBackColor
                            view="gradient"
                        ></kendo-toolbar-colorpicker>
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                    </kendo-toolbar>
                </kendo-editor>
            }
        } @else {
            @if (item.type === 'Texte') {
                <div [innerHTML]="html(item)"></div>
                <!--<hr />
                DEBUG:
                {{ item.bloc }}
                <hr />-->
            }
        }
    </div>
} @empty {
    <div>Empty</div>
}
